import React from "react";
import "./Preloading.css";
// import s1 from '../../assets/img/s1.png'
// import s2 from '../../assets/img/s2.png'
// import s3 from '../../assets/img/s3.png'
// import s4 from '../../assets/img/s4.png'
import logoImage from "../../assets/img/new_logo.jpg";

// import s1 from "../../assets/img/01.jpg";
// import s2 from "../../assets/img/02.jpg";
// import s3 from "../../assets/img/03.jpg";
// import s4 from "../../assets/img/04.jpg";
// import s5 from "../../assets/img/05.jpg";
// import s6 from "../../assets/img/06.jpg";
// import s7 from "../../assets/img/07.jpg";
// import s8 from "../../assets/img/08.jpg";
// import s9 from "../../assets/img/09.jpg";

export default function Preloading() {
  // return (
  //   <div className='containerOfPreloading'>
  //     <section>
  //       <div className='sk-cube-grid'>
  //         <div className='sk-cube sk-cube-1'
  //           style={{
  //             backgroundImage:`url(${s1})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-2'
  //           style={{
  //             backgroundImage:`url(${s2})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-3'
  //           style={{
  //             backgroundImage:`url(${s3})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-4'
  //           style={{
  //             backgroundImage:`url(${s4})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-5'
  //           style={{
  //             backgroundImage:`url(${s5})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-6'
  //           style={{
  //             backgroundImage:`url(${s6})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-7'
  //           style={{
  //             backgroundImage:`url(${s7})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-8'
  //           style={{
  //             backgroundImage:`url(${s8})`,
  //           }}
  //         ></div>
  //         <div className='sk-cube sk-cube-9'
  //           style={{
  //             backgroundImage:`url(${s9})`,
  //           }}
  //         ></div>
  //       </div>
  //     </section>
  //   </div>
  // )
  return (
    <div className="containerOfLoadingAnimation">
      <div className="first">
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
      <div className="second">
        <ul>
          <li></li>
          <li></li>
        </ul>
      </div>
      <div className="third">
        <ul>
          <li></li>
          <li></li>
          <li className="floating-1"></li>
          <li className="floating-1"></li>
          <li className="floating-2"></li>
          <li className="floating-2"></li>
        </ul>
      </div>
      <div className="fourth">
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li className="floating"></li>
          <li className="floating"></li>
          <li className="floating"></li>
          <li className="floating"></li>
        </ul>
        {/* <span className="smile"></span>
        <span className="eyes"></span>
        <span className="cheeks"></span> */}
        <img
          style={{
            width:'35px',
            height:'35px',
            objectFit:'cover',
            backgroundPosition:'center center',
            position:'relative',
            top:'-57px',
            left:'25px'
          }}
          src={logoImage}
        />
      </div>

      <div className="random-stars-container">
        <span className="random-stars"></span>
        <span className="random-stars"></span>
        <span className="random-stars"></span>
        <span className="random-stars"></span>
      </div>
    </div>
  );
}
